module.exports = __webpack_public_path__ + "static/img/video-text-cn.07781d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/video-text-cn.png
// module id = 5JJK
// module chunks = 1